import "./styles/runtag.css";
import type { ModeKind, RunKind } from "@highmarch/app";
import { icon } from "./iconsKit";
import { challengeGlyph, dailyGlyph, infinityGlyph } from "./modeGlyphs";

/**
 * The Heroic / Weekly Trial / Iron / Endless tag on the level's HUD (FINISH_PLAN WP9; the gap WP6 left, W2 notes): a small ribbon
 * hanging under the HUD plate, so a modified run never looks like a plain one. It says what the run is, nothing
 * more (the Events sheet and the end screen say what it pays). Captain Bram's hint.heroic / hint.trial point at it.
 */
type TagKind = NonNullable<RunKind> | NonNullable<ModeKind>;
const LABEL: Readonly<Record<TagKind, string>> = { heroic: "HEROIC", trial: "WEEKLY TRIAL", iron: "IRON", endless: "ENDLESS", daily: "DAILY ROAD", challenge: "CHALLENGE", boss: "BOSS WEEK", race: "RACE WEEK", odyssey: "ODYSSEY" };
const ICON: Readonly<Record<TagKind, string>> = { heroic: "flame", trial: "bolt", iron: "iron", endless: "", daily: "", challenge: "", boss: "skull", race: "fast", odyssey: "map" };
/** The glyph beside the word, CSS px. */
const TAG_ICON_PX = 12;

/** Puts the tag for `kind` on the HUD in `ui` (replacing any), or removes it for a plain run. */
export function mountRunTag(ui: ParentNode, kind: RunKind | ModeKind): HTMLElement | null {
  const hud = ui.querySelector<HTMLElement>("#hud");
  hud?.querySelector(".runtag")?.remove();
  if (!hud || kind === null) return null;
  const tag = document.createElement("span");
  tag.className = `runtag ${kind} disp`;
  tag.setAttribute("role", "note");
  tag.innerHTML = `${kind === "endless" ? infinityGlyph(TAG_ICON_PX + 2) : kind === "daily" ? dailyGlyph(TAG_ICON_PX + 2) : kind === "challenge" ? challengeGlyph(TAG_ICON_PX + 2) : icon(ICON[kind], TAG_ICON_PX)}<span>${LABEL[kind]}</span>`;
  hud.append(tag);
  return tag;
}
